export default __webpack_public_path__ + "2ab5b7d.png";